<template>
  <v-card elevation="0" outlined class="profile-list">
    <v-container fluid class="py-10">
      <v-row>
        <v-col cols="6" class="d-flex align-center">
          <p class="pl-4 ma-0">TEAM MEMBERS</p>
        </v-col>
        <v-col cols="12" md="4" class="d-flex flex-row-reverse">
          <v-btn>Import User</v-btn>
        </v-col>
        <v-col cols="12" md="2" class="d-flex flex-row-reverse">
          <v-btn>Add User</v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="text-center">
      <v-row no-gutters class="d-flex align-center border-bottom pb-5">
        <v-col cols="12" sm="2">
          <!-- <v-checkbox label="aa"></v-checkbox> -->
        </v-col>
        <v-col cols="12" sm="2" class="d-flex align-center">
          <p class="pl-4 ma-0">Full Name</p>
        </v-col>
        <v-col cols="12" sm="2" class="d-flex align-center">
          <p class="pl-4 ma-0">Role</p>
        </v-col>
        <v-col cols="12" sm="2" class="d-flex align-center">
          <p class="pl-4 ma-0">Created</p>
        </v-col>
        <v-col cols="12" sm="2" class="d-flex align-center">
          <p class="pl-4 ma-0">Status</p>
        </v-col>
        <v-col cols="12" sm="2" class="d-flex align-center">
          <p class="pl-4 ma-0"></p>
        </v-col>
      </v-row>
      <v-row
        v-for="n in counter"
        :key="n"
        no-gutters
        class="d-flex align-center text-body-2 border-bottom"
      >
        <v-col cols="12" sm="2">
          <v-checkbox :data-counter="n + listCounter" label=""></v-checkbox>
        </v-col>
        <v-col
          cols="12"
          sm="2"
          v-for="i in showList.length"
          :key="i"
          no-gutters
          class="d-flex align-center"
        >
          <p class="pl-4 ma-0">
            {{ UserList[n + listCounter][showList[i - 1]] }}
          </p>
        </v-col>

        <v-col cols="12" sm="2">
          <v-btn
            plain
            :data-counter="n + listCounter"
            @click.stop="selectUser(UserList[n + listCounter])"
            class="d-flex align-center mr-4"
            >Edit</v-btn
          >
        </v-col>
      </v-row>

      <v-container fluid class="pt-10">
        <v-row>
          <v-col cols="3" align="left">
            <v-select
              label="Rows Per Page"
              :items="rowsPerPageItems"
              v-model="rowsPerPage"
            />
          </v-col>
          <v-col cols="3" align="right" class="offset-sm-3">
            {{ currentCount }}-{{ maxCount }} of {{ max }}
          </v-col>
          <v-col cols="3" align="right">
            <v-container class="d-flex align-center">
              <v-btn @click="page--" v-show="showPrevious" class="ml-5"
                >Previous</v-btn
              >
              <v-btn @click="page++" v-show="showNext" class="ml-5">Next</v-btn>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
      <!-- </v-pagination> -->
    </v-container>

    <v-navigation-drawer floating right absolute temporary v-model="drawer">
      <template v-slot:prepend>
        <v-container fluid class="py-10">
          <v-row>
            <v-col cols="6" class="align-center">
              <h1 class="pl-4 ma-0">{{ user.name }}</h1>
              <h1 class="pl-4 ma-0 grey--text text--lightend-5">
                {{ user.role }}
              </h1>
            </v-col>
            <v-col cols="12" md="3" align="right">
              <v-btn @click.stop="showForm">Save</v-btn>
            </v-col>
            <v-col cols="12" md="3" align="right">
              <v-btn @click.stop="showForm">Cancel</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <v-divider></v-divider>

      <v-container fluid class="py-10">
        <v-row>
          <v-col cols="12" md="5" class="align-center">
            <v-card elevation="0" class="px-5" outlined>
              <v-row>
                <v-col cols="12" class="align-center">
                  <h2 class="pt-5 ma-0 grey--text text--lightend-5">Contact</h2>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="align-center">
                  <v-text-field label="First Name"></v-text-field>
                </v-col>
                <v-col cols="6" class="align-center">
                  <v-text-field label="Last Name"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="align-center">
                  <v-text-field label="Email"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="align-center">
                  <v-text-field label="Mobile"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" align="left">
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        Address
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="12" class="align-center">
                            <v-text-field label="Street Adress"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6" class="align-center">
                            <v-text-field label="Ottawa"></v-text-field>
                          </v-col>
                          <v-col cols="6" class="align-center">
                            <v-text-field label="Province"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" class="align-center">
                            <v-text-field label="Postal Code"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="align-left">
                  <v-textarea label="Notes"></v-textarea>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12" md="7" class="align-center">
            <v-card elevation="0" class="px-5" outlined>
              <v-row>
                <v-col cols="12" class="align-center">
                  <h2 class="pt-5 ma-0 grey--text text--lightend-5">Contact</h2>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="align-center">
                  <v-select
                    label="Role"
                    :items="rowsPerPageItems"
                    v-model="rowsPerPage"
                  />
                </v-col>
                <v-col cols="6" class="align-center">
                  <v-select
                    label="Function"
                    :items="rowsPerPageItems"
                    v-model="rowsPerPage"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="align-center">
                  <v-text-field label="Funding"></v-text-field>
                </v-col>
                <v-col cols="6" class="align-center">
                  <v-text-field label="Status"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="align-center">
                  <v-select
                    v-model="groupsValues"
                    :items="rowsPerPageItems"
                    attach
                    chips
                    label="Organization"
                    multiple
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="align-center">
                  <v-select
                    v-model="groupsValues"
                    :items="rowsPerPageItems"
                    attach
                    chips
                    label="Groups"
                    multiple
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="align-center">
                  <v-select
                    v-model="eventsValues"
                    :items="rowsPerPageItems"
                    attach
                    chips
                    label="Events"
                    multiple
                  ></v-select>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-navigation-drawer>
  </v-card>
</template>

<script>
export default {
  name: "ProfileList",
  data() {
    return {
      drawer: false,
      rowsPerPage: 10,
      rowsPerPageItems: [10, 50, 100, 500],
      max: 100,
      page: 1,
      user: {},
      selectValues: [],
      groupsValues: [],
      eventsValues: [],
    };
  },
  props: {
    UserList: {},
    showList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    // Value for the For Loop
    // return rows per page if the List COunter + rows is smaller then the max
    counter: function() {
      return this.listCounter + this.rowsPerPage > this.max - 1
        ? this.rowsPerPage - (this.page * this.rowsPerPage - this.max)
        : this.rowsPerPage;
    },

    // Iterator for the array.
    // Arrays are indexed at 0 so we need to remove 1 from  current count
    listCounter: function() {
      return this.page == 1 ? -1 : this.currentCount - 2;
    },

    // Value Showed to the user
    // Starts at 1 if the page is 1
    currentCount: function() {
      return this.page == 1
        ? 1
        : this.page * this.rowsPerPage - this.rowsPerPage + 1;
    },
    maxCount: function() {
      return this.page * this.rowsPerPage > this.max
        ? this.max
        : this.page * this.rowsPerPage;
    },
    nextPage: function() {
      return this.page + 1;
    },
    showNext: function() {
      return (
        this.page * this.rowsPerPage + this.rowsPerPage <=
        this.max + this.rowsPerPage
      );
    },
    previousPage: function() {
      return this.page - 1;
    },
    showPrevious: function() {
      return this.page > 1;
    },
  },
  methods: {
    showForm() {
      this.drawer = !this.drawer;
    },
    selectUser(user) {
      this.showForm();
      this.user = user;
    },
  },
  beforeMount() {
    this.max = this.UserList.length;
  },
};
</script>

<style lang="scss">
.profile-list {
  .border-bottom {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  }

  .v-navigation-drawer {
    position: fixed;
    width: 70% !important;
  }
  .v-overlay--active {
    position: fixed;
  }
}
</style>
